import * as React from "react";

import { useGtm } from "../../../Common";

import { ReactPdpAnalyticsInterface } from "./analytics-interface";

export const useAnalyticsGtm = (): ReactPdpAnalyticsInterface => {
  const { pushToTheDataLayer, consumerInitializationGuard } = useGtm();

  const viewActionOnProduct: NonNullable<
    ReactPdpAnalyticsInterface["viewActionOnProduct"]
  > = React.useCallback(
    ({ productId }) => {
      let event = {
        event: "viewActionOnProduct",
        target: {
          product: `${productId}`,
        },
      };

      pushToTheDataLayer(event);
    },
    [pushToTheDataLayer]
  );

  const addToCartAction: NonNullable<
    ReactPdpAnalyticsInterface["addToCartAction"]
  > = React.useCallback(
    ({ productId, quantity }) => {
      let event = {
        event: "addToCartAction",
        target: {
          product: `${productId}`,
        },
        metadata: {
          quantity,
        },
      };

      pushToTheDataLayer(event);
    },
    [pushToTheDataLayer]
  );

  const addToWishlistAction: NonNullable<
    ReactPdpAnalyticsInterface["addToWishlistAction"]
  > = React.useCallback(
    ({ sku, price, qty, name }) => {
      let event = {
        event: "wishlist_add_item",
        wishlist: {
          sku: [sku],
          price: price,
          qty: qty,
          name: name,
        },
      };

      let eventGA4 = {
        event: "add_to_wishlist",
        ecommerce: {
          currency: "AUD",
          value: price,
          items: [
            {
              item_id: sku,
              price: price,
              quantity: qty,
              item_name: name,
            },
          ],
        },
      };

      pushToTheDataLayer(event);
      pushToTheDataLayer(eventGA4);
    },
    [pushToTheDataLayer]
  );

  const initializedInterface: ReactPdpAnalyticsInterface = React.useMemo(
    () => ({
      hasInitialized: true,
      viewActionOnProduct,
      addToCartAction,
      addToWishlistAction,
    }),
    [viewActionOnProduct, addToCartAction, addToWishlistAction]
  );
  const analyticsInterface = consumerInitializationGuard({
    initializedInterface,
  });
  return analyticsInterface;
};
